export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '8c1e7820-8c29-4b58-82df-f06194923db9';
export const MODAL_CLOSE_SEC = 2.5;
